import Mic from "@mui/icons-material/Mic";
import MicOff from "@mui/icons-material/MicOff";
import { Box } from "@mui/material";

function VolumeVisualizer({
  volume,
  activeMicrophone,
}: {
  volume: number;
  activeMicrophone: boolean;
}) {
  const volumeLevel = Math.round((volume * 100) / 7);
  const activeBoxes = Math.floor(volumeLevel / 10);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        {activeMicrophone ? (
          <Mic color={activeBoxes ? "primary" : "disabled"} />
        ) : (
          <MicOff color="disabled" />
        )}
        {Array.from({ length: 10 }, (_, index) => (
          <Box
            key={index}
            sx={{
              width: 18,
              height: 18,
              backgroundColor:
                index < activeBoxes ? "primary.main" : "rgba(0, 0, 0, 0.2)",
              borderRadius: "50%",
            }}
          />
        ))}
      </Box>
    </>
  );
}

export default VolumeVisualizer;
